/** Как в классическом интерфейсе: выбор тикетов переживает обновление страницы в сессии */
const SESSION_KEY = 'tickets-selected-ids'

export function loadTicketsSelectionIds(): string[] {
  try {
    const s = sessionStorage.getItem(SESSION_KEY)
    if (!s) return []
    const arr = JSON.parse(s) as unknown
    if (!Array.isArray(arr)) return []
    return arr.map(String).filter(Boolean)
  } catch {
    return []
  }
}

export function saveTicketsSelectionIds(ids: ReadonlySet<string>): void {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(Array.from(ids)))
  } catch {
    /* ignore */
  }
}
